<template>
  <div class="px-8 py-6" style="height:100%; width:100%;">
    <h3>사용자관리</h3>
    <div class="d-flex pb-2 pt-5">
      <div class="pr-5">
        <v-select
          v-resize="updateWindowHeight"
          :items="search"
          label="검색항목검색"
          height="28"
          class="width160-height30 border-5c5c5c "
          solo
          flat
          dense
          v-model="searchCategory"
          :menu-props="{ offsetY: true }"
        />
      </div>
      <div class="pr-5">
        <input
          v-model="searchWord"
          class="cursor-pointer border-5c5c5c  width300-height30"
          @keyup.enter="searchUser"
        />
      </div>
      <v-btn
        color="#3F557D"
        class="color-white"
        width="78"
        height="30"
        @click="searchUser"
        >조회</v-btn
      >
      <v-spacer />
      <v-btn
        color="#ffffff"
        class="add-btn"
        width="120"
        height="30"
        @click="addUser()"
        >유저추가
      </v-btn>
    </div>
    <div justify="center" class="pt-5">
      <v-simple-table
        class="mb-5 width-100"
        fixed-header
        :height="windowInnerHeight - 48 - 175"
        dense
      >
        <thead>
          <tr>
            <th
              class="back-8ca9dd color-white text-center "
              v-for="item in header"
              :key="item"
              :class="item != '등록일자' ? 'border-right-white' : ''"
            >
              {{ item }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in userList" :key="list.accountName" height="40">
            <td
              class="border-right-aaaaaa border-bottom-aaaaaa border-left-aaaaaa back-white text-left pl-1"
            >
              {{ list.companyType }}
            </td>
            <td
              class="border-right-aaaaaa border-bottom-aaaaaa text-left pl-1 back-white "
            >
              <v-btn
                @click="addUser(list.userId)"
                color="#5BB1EA"
                class="text-none"
                text
              >
                {{ list.accountName }}
              </v-btn>
            </td>
            <td
              class="border-right-aaaaaa border-bottom-aaaaaa text-left pl-1 back-white "
            >
              <v-btn
                @click="addUser(list.userId)"
                color="#5BB1EA"
                text
                class="text-none"
              >
                {{ list.userName }}
              </v-btn>
            </td>
            <td
              class="border-right-aaaaaa border-bottom-aaaaaa text-left pl-1 back-white"
            >
              {{ list.phoneNumber }}
            </td>
            <td
              class="border-right-aaaaaa border-bottom-aaaaaa text-left pl-1 back-white constructionname"
            >
              {{ list.constructionName }}
            </td>
            <td
              class="border-right-aaaaaa border-bottom-aaaaaa text-left pl-1  back-white"
            >
              {{ list.companyName }}
            </td>
            <td
              class="border-right-aaaaaa border-bottom-aaaaaa text-left pl-1  back-white"
            >
              {{ list.registDate | moment("YY.MM.DD") }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import UserApi from "@/api/UserService";
import Commonality from "@/mixin/Commonality";
export default {
  mixins: [Commonality],

  data: () => ({
    search: ["업체구분", "아이디", "이름", "전화번호", "현장명", "회사명"],
    searchWord: "",
    userList: [],
    searchCategory: "",
    userTotalArray: [],
    header: [
      "업체구분",
      "아이디",
      "이름",
      "전화번호",
      "현장명",
      "회사명",
      "등록일자",
    ],
    windowInnerHeight: 0,
  }),
  created() {
    this.$bus.$on("deleteOnUser", (val) => {
      if (val) this.$router.push({ name: "User" });
    });
    this.startAndReset();
    this.$bus.$on("userNavigationDuplicated", () => {
      this.startAndReset();
    });
  },

  beforeDestroy() {
    this.$bus.$off("userNavigationDuplicated");
  },

  methods: {
    /** 윈도우 동적높이 가져오는 함수 */
    updateWindowHeight() {
      if (typeof window !== "undefined") {
        this.windowInnerHeight = window.innerHeight;
      }
    },
    async startAndReset() {
      let data = { constructionId: null };
      if (this.userState == "현장관리자")
        data.constructionId = this.constructionId;
      let resultData = await UserApi.userTotalList(data);
      this.userTotalArray = resultData.data.userlist;
      this.userList = this.userTotalArray;
      this.searchCategory = "업체구분";
    },

    addUser(data) {
      this.$router.push({
        name: "AddUser",
        params: {
          userId: data,
        },
      });
    },

    searchUser() {
      if (this.searchWord == "") return (this.userList = this.userTotalArray);
      if (this.searchCategory == "업체구분") {
        this.userList = this.userTotalArray.filter((userList) =>
          userList.companyType
            ? userList.companyType.includes(this.searchWord)
            : false
        );
      } else if (this.searchCategory == "아이디") {
        this.userList = this.userTotalArray.filter((userList) =>
          userList.accountName
            ? userList.accountName.includes(this.searchWord)
            : false
        );
      } else if (this.searchCategory == "이름") {
        this.userList = this.userTotalArray.filter((userList) =>
          userList.userName
            ? userList.userName.includes(this.searchWord)
            : false
        );
      } else if (this.searchCategory == "전화번호") {
        this.userList = this.userTotalArray.filter((userList) =>
          userList.phoneNumber
            ? userList.phoneNumber.includes(this.searchWord)
            : false
        );
      } else if (this.searchCategory == "회사명") {
        this.userList = this.userTotalArray.filter((userList) =>
          userList.companyName
            ? userList.companyName.includes(this.searchWord)
            : false
        );
      } else if (this.searchCategory == "현장명") {
        this.userList = this.userTotalArray.filter((userList) =>
          userList.constructionName
            ? userList.constructionName.includes(this.searchWord)
            : false
        );
      }
    },
  },
};
</script>

<style scoped>
.add-btn {
  border-color: black !important;
  border: 1px solid black;
}
.constructionname {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.w-100 {
  width: 100px !important;
}
.w-95 {
  width: 95px !important;
}
.width160-height30 {
  width: 160px;
  height: 30px !important;
}
</style>
